// Module
var code = `<div class="alert" ng-if="!\$ctrl.hasFullAccess()" command-access="GrantCustomerAccess">
  <div class="message-container">
    <div>
      <span>Products from other branches might have been hidden.</span>
      <span ng-if="!\$ctrl.requestedAccess()">To see them you need to request for access.</span>
      <span ng-if="\$ctrl.requestedAccess() && !\$ctrl.accessRejected()">Your access to products has not been granted.</span>
      <span ng-if="\$ctrl.accessRejected()">Your request for access to products from other branches has been rejected.</span>
    </div>
  </div>
  <div class="button-container">
    <button
      ng-if="!\$ctrl.requestedAccess() || \$ctrl.accessRejected()"
      class="btn btn-success"
      ng-click="\$ctrl.requestAccess()"
      type="button">
      Request access
    </button>
    <button
      ng-if="\$ctrl.requestedAccess() && !\$ctrl.accessRejected()"
      class="btn btn-success"
      ng-click="\$ctrl.checkAccess()"
      type="button">
      Check your access
    </button>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/customer-access/customer-access.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;